import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Head } from '@/components/seo/Head/Head';
import { GenericIconScreen } from '@/components/shared/GenericIconScreen/GenericIconScreen';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { BadgeHelp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const NotFoundRoute = () => {
  const { t } = useTranslation('utils', {
    keyPrefix: 'notFoundPage',
  });

  return (
    <GenericLayout>
      <Head title={t('seo.title')} />
      <GenericIconScreen
        Icon={BadgeHelp}
        title={t('title')}
        description={t('description')}
        leftActionElement={
          <Button asChild>
            <Link to={paths.home.path}>{t('button.label')}</Link>
          </Button>
        }
      />
    </GenericLayout>
  );
};
